// Only explicit working facts; venue-rental budget is not an ad budget.
export const promotionPrefill = (state, role) => {
  if (!state || role !== 'organizer') return {};
  const facts = state.facts || {}, filters = state.filters || {}, project = state.project || {};
  const title = project.title || facts.topic;
  const region = (facts.preferred_districts || filters.preferred_districts || project.preferred_districts || []).join(', ');
  const count = facts.expected_attendees || filters.expected_attendees || project.expected_attendees;
  const date = /^\d{4}-\d{2}-\d{2}$/.test(facts.date_text || '') ? facts.date_text : '';
  const budget = facts.promotion_budget_try;
  const parts = [title, region, count ? `${count} kişi` : '', facts.date_text].filter(Boolean);
  return { ...(title ? { title } : {}), ...(region ? { region } : {}), ...(date ? { event_date: date } : {}),
    ...(typeof budget === 'number' && budget > 0 ? { budget_try: String(budget) } : {}),
    ...(parts.length ? { brief: parts.join(' · ') } : {}) };
};
